/** Show booking/testimonial prompt when pausing or stopping a tracker. */
export function shouldPromptTrackerFeedback(tracker) {
  if (!tracker?.hasClickedNotification || tracker?.hasTestimonial) {
    return false;
  }
  if (tracker.booked === false) {
    return false;
  }
  return true;
}

export function shouldSkipToTestimonial(tracker) {
  return tracker?.booked === true && !tracker?.hasTestimonial;
}
